import type { ReactNode } from "react";

/** ログイン系画面の外枠（C-15・ops ログイン共通）。 */
export function AuthCard({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main
      style={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        padding: "var(--kz-space-4)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          background: "var(--kz-color-surface)",
          border: "1px solid var(--kz-color-border)",
          borderRadius: "var(--kz-radius-lg)",
          boxShadow: "var(--kz-shadow-card)",
          padding: "var(--kz-space-6)",
        }}
      >
        <h1 style={{ margin: 0, fontSize: "var(--kz-font-size-xl)" }}>{title}</h1>
        {subtitle ? (
          <p
            style={{
              margin: "var(--kz-space-1) 0 var(--kz-space-5)",
              fontSize: "var(--kz-font-size-sm)",
              color: "var(--kz-color-ink-muted)",
            }}
          >
            {subtitle}
          </p>
        ) : (
          <div style={{ height: "var(--kz-space-5)" }} />
        )}
        {children}
        {footer ? <div style={{ marginTop: "var(--kz-space-5)" }}>{footer}</div> : null}
      </div>
    </main>
  );
}
